// set function parseTime,formatTime to filter
export { parseTime, formatTime } from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 购物车产品规格重组
export function regroupSpec(str) {
  if (!str) return ''
  const obj = JSON.parse(str)
  var str2 = ''
  for (var key in obj) {
    str2 += key + '：' + obj[key] + '　'
  }
  return str2
}

// 获取规格
export function getSpec(str) {
  if (!str) return ''
  const obj = JSON.parse(str)
  var str2 = ''
  for (var key in obj) {
    str2 += obj[key] + '　'
  }
  return str2
}

// 订单状态
export function getOrderState(state) {
  switch (state) {
    case -2 :return '已退款'
    case -1 :return '已撤销'
    case 0 :return '待付款'
    case 1 :return '已支付'
    case 2 :return '已发货'
    case 3 :return '待评价'
    case 4 :return '已完成'
    default:return '状态异常'
  }
}
